<div class="stepper-3">
    <div class="stepper-3-title">
        <h1>{{ "create-assignment.assignment-title" | translate }}</h1>
    </div>
    <div class="step-3-wrap" #step3top>
        <div class="wrap-left-box">
            <div class="calendar-wrapper">
                <label class="calendar-label">
                    <label class="calendar-label">
                        {{ "create-assignment.select-dates" | translate }} <span class="required">*</span>
                    </label>
                </label>
                <ejs-calendar #calendar [values]="initDates" locale="{{ locale }}" [isMultiSelection]="multiselect"
                    depth="Month" [firstDayOfWeek]="1" [min]="minDatePicker" weekNumber="true"
                    (change)="onChangeCalendar($event.values)" (renderDayCell)="onRenderDayCell($event)"></ejs-calendar>
            </div>
            <div class="job-location-card">
                <div class="card-header">
                    <h3>
                        {{ "create-assignment.step3.job-location" | translate }}
                    </h3>
                    <i>
                        <img loading="lazy" src="../../../../../assets/img/location.svg" alt="location" />
                    </i>
                </div>
                <div class="job-location-fields">
                    <div class="field-group">
                        <div class="label-row">
                            <label for="jobAddress">
                                {{ "create-assignment.step3.location" | translate }}
                                <span class="required">*</span>
                            </label>
                            <button class="recent-btn" (click)="openRecentLocations()">
                                <i>
                                    <img loading="lazy" src="../../../../../assets/img/time.svg" alt="time" />
                                </i>
                                <span>{{ "create-assignment.step3.recent-locations" | translate }}</span>
                                <svg class="icon chevron-down" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path d="m6 9 6 6 6-6" />
                                </svg>
                            </button>
                        </div>
                        <div class="input-wrapper">
                            <input type="text" id="locationSearch" #search [(ngModel)]="searchJobs"
                                placeholder="{{ 'create-assignment.step3.location-search-placeholder' | translate }}"
                                (input)="keyUpAddress($event)" (paste)="onAddressPaste($event)"
                                (focus)="onSearchFocus()" autocomplete="off" />
                            <img class="icon search" src="../../../../../assets/img/search 1.svg" alt="search" />
                        </div>
                        <div class="select-dropdown" *ngIf="isJobOpen">
                            <div class="recent-title">
                                {{ "create-assignment.step3.recent-locations" | translate }}
                            </div>
                            <div class="options-list">
                                <div *ngIf="isJobOpen">
                                    <div *ngIf="objects?.length > 0; else noData">
                                        <div *ngFor="let object of uniqueObjects" (click)="onChangeObject(object)"
                                            class="option-item" [class.selected]="selectedObject?.id === object.id">
                                            {{ object.name }} - {{ object.address }}
                                        </div>
                                    </div>
                                    <ng-template #noData>
                                        <div class="no-data-found">{{ "create-assignment.step3.no-data-found" |
                                            translate }}</div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                        <div class="map-preview" *ngIf="!marker || !center">
                            <div class="preview-header">
                                <label>{{ "create-assignment.step3.map-preview" | translate }}</label>
                            </div>
                            <div class="map-container">
                                <div class="map-placeholder">
                                    <img class="icon search" src="../../../../../assets/img/maps.svg" alt="search" />
                                    <p>{{ "create-assignment.step3.enter-address" | translate }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="map-preview" *ngIf="marker && center">
                            <div class="preview-header">
                                <label>{{ "create-assignment.step3.map-preview" | translate }}</label>
                            </div>
                            <div class="col-12 google-map-container">
                                <google-map height="300px" width="100%" [zoom]="zoom" [options]="mapOptions"
                                    [center]="center">
                                    <map-advanced-marker [position]="marker.position"></map-advanced-marker>
                                </google-map>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="job-description">
                <div class="job-title">
                    <h1 class="job-title-text">
                        {{ "create-assignment.step3.job-description" | translate }}
                        <p class="faded-p">
                            {{ "create-assignment.optional" | translate }}
                        </p>
                    </h1>
                    <img loading="lazy" src="../../../../../assets/img/folder-blue.svg" alt="folder-blue" />
                </div>
                <form class="form-box">
                    <label for="">{{ "create-assignment.step3.description" | translate }}</label>
                    <textarea name="description" id="" rows="5" placeholder="" [(ngModel)]="description"></textarea>
                </form>
            </div>
        </div>
        <div class="wrap-right-box">
            <div class="card">
                <div class="card-header-box">
                    <h3 class="card-title">
                        {{ "create-assignment.step3.personnel-options" | translate }}
                        <span class="required">*</span>
                    </h3>
                    <button class="help-btn tooltip-wrapper" aria-label="Help">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                            <path d="M12 17h.01"></path>
                        </svg>
                        <div class="custom-tooltip"
                            [innerHTML]="'create-assignment.step3.personnel-options-tooltip' | translate"></div>
                    </button>
                </div>

                <div class="option-list">
                    <div class="option tooltip-container" [ngClass]="{
                            'selected': handPick == 1,
                            'disabled': !dates.length || !center || !marker
                        }" (click)="(!dates.length || !center || !marker) ? null : selectHandPick('1')"
                        *ngIf="this.assignmentType == '1'"
                        [attr.disabled]="!dates.length || !center || !marker ? true : null">
                        <div class="option-content">
                            <div class="option-radio"
                                (click)="(!dates.length || !center || !marker) ? null : selectHandPick('1')">
                                <input type="radio" name="personnel" value="1" [(ngModel)]="handPick"
                                    [disabled]="!dates.length || !center || !marker" checked
                                    aria-label="Personnel apply" />
                            </div>
                            <div>
                                <h4 class="option-title">
                                    {{ "create-assignment.step3.personnel-apply.label" | translate }}
                                </h4>
                            </div>
                        </div>
                        <div class="hoverbox">
                            <h4>
                                {{ "create-assignment.step3.personnel-apply-hover-message.heading" | translate }}
                            </h4>
                            <p
                                [innerHTML]="'create-assignment.step3.personnel-apply-hover-message.description' | translate">
                            </p>
                        </div>

                        <div class="info-icon-container">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="info-icon">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="M12 16v-4"></path>
                                <path d="M12 8h.01"></path>
                            </svg>
                        </div>
                    </div>

                    <div class="optionbox tooltip-container" [ngClass]="{
                            'selected': handPick == 0,
                            'disabled': !dates.length || !center || !marker
                        }" *ngIf="this.assignmentType == '1'"
                        [attr.disabled]="!dates.length || !center || !marker ? true : null">
                        <div class="option-content">
                            <div class="option-radio"
                                (click)="(!dates.length || !center || !marker) ? null : selectHandPick('0')">
                                <input type="radio" name="personnel" value="0" [(ngModel)]="handPick"
                                    [disabled]="!dates.length || !center || !marker" aria-label="Hand pick personnel" />
                            </div>
                            <div (click)="(!dates.length || !center || !marker) ? null : selectHandPick('0')">
                                <h4 class="option-title">
                                    {{ "create-assignment.step3.hand-pick-personnel.label" | translate }}
                                </h4>
                            </div>
                            <div class="hoverbox">
                                <h4>
                                    {{ "create-assignment.step3.hand-pick-personnel-hover-message.heading" | translate
                                    }}
                                </h4>
                                <p [innerHTML]="
                                        'create-assignment.step3.hand-pick-personnel-hover-message.description'
                                            | translate
                                    "></p>
                            </div>
                            <div class="info-icon-container">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="info-icon">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <path d="M12 16v-4"></path>
                                    <path d="M12 8h.01"></path>
                                </svg>
                            </div>
                        </div>

                        <div class="optionboxContent" *ngIf="handPick == '0'">
                            <div class="guardsName">
                                <input type="text" [placeholder]="
                                        'create-assignment.step3.searchGuards.placeholder'
                                            | translate
                                    " class="" [(ngModel)]="searchGuards" (input)="keyUpSearchGuards($event)" />
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-search absolute left-3 top-1/2 transform -translate-y-1/2 text-[#93c5fd]"
                                    aria-hidden="true">
                                    <path d="m21 21-4.34-4.34"></path>
                                    <circle cx="11" cy="11" r="8"></circle>
                                </svg>
                            </div>
                            <div class="mt-4">
                                <div class="filter-container">
                                    <p class="filter-label">
                                        {{ "create-assignment.step3.FilterBy" | translate }}:
                                    </p>
                                    <mat-chip-listbox aria-label="Filter options" class="chip-list"
                                        ([ngModel])="(filterby)" (change)="onChangeFilterby($event)">
                                        @for (item of filterbyOption; track
                                        item) {
                                        <mat-chip-option [selected]="filterby === item" [ngClass]="
                                                filterby == item
                                                    ? 'chip-option'
                                                    : ''
                                            ">{{ item | translate }}</mat-chip-option>
                                        }
                                    </mat-chip-listbox>
                                </div>

                                <div class="flex justify-between mb-3 availableGuards">
                                    <h5 class="text-sm font-medium text-[#1d4ed8] flex items-center">
                                        {{ "create-assignment.step3.available-guards" | translate }}
                                        <span>{{ guardsPagination?.total || 0 }}</span>
                                    </h5>
                                    <div class="med-dig">
                                        {{ showingFilterText }}
                                    </div>
                                </div>
                                <div class="usercardmainBox" id="hand-pick-id" (scroll)="onScrollGuards($event)">
                                    <div *ngFor="
                                            let guard of guards;
                                            let inx = index
                                        ">
                                        <div *ngIf="
                                                !(
                                                    showAllRecords &&
                                                    handPickButtonName(
                                                        guard
                                                    ) ===
                                                        ('create-assignment.step3.added'
                                                            | translate)
                                                )
                                            ">
                                            <div class="usercard">
                                                <div class="userName w-full flex gap-3">
                                                    <div class="grid gap-2 w-full">
                                                        <div class="flex gap-2" (click)="openGuardDetailsModal(guard)">
                                                            <div class="userImage">
                                                                <img src="{{
                                                                        guard.image ||
                                                                            '/assets/img/empty-profile-picture.png'
                                                                    }}" alt="{{
                                                                        guard?.firstName
                                                                    }}" />
                                                            </div>
                                                            <div
                                                                class="flex items-center gap-2 w-[calc(100%-60px)] !flex-wrap md:!flex-nowrap">
                                                                <div class="">
                                                                    <p class="font-medium text-gray-800 m-0">{{
                                                                        guard?.firstName }}</p>
                                                                    <div class="flex items-center gap-1">
                                                                        <ngb-rating max="5" [rate]="
                                                                                guard?.averageRating
                                                                            " [readonly]="
                                                                                true
                                                                            "></ngb-rating>
                                                                        <span class="text-xs text-gray-500 ml-1.5">{{
                                                                            guard?.averageRating }}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                                <div class="ml-auto">
                                                                    <button class="addButtpon min-w-[86px]" (click)="
                                                                            onChangePersonnel(
                                                                                guard
                                                                            )
                                                                        ">
                                                                        <img src="{{
                                                                                isGuardSelected(
                                                                                    guard
                                                                                )
                                                                                    ? '../../../../../assets/img/checked white.svg'
                                                                                    : '../../../../../assets/img/plus white.svg'
                                                                            }}" alt="" />
                                                                        {{ handPickButtonName(guard) }}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="userNameReview flex gap-2">
                                                            <div class="grid gap-2">
                                                                <div class="reviewSection">
                                                                    <div class="flex-colbox-wrap">
                                                                        <div class="Previous-btn" *ngIf="
                                                                                filterby !==
                                                                                ('create-assignment.step3.filter.highestRated'
                                                                                    | translate)
                                                                            ">
                                                                            <button>
                                                                                {{ "create-assignment.step3.Previous" |
                                                                                translate }}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                    <span class="previousJob">{{
                                                                        filterby ===
                                                                        ("create-assignment.step3.filter.highestRated"
                                                                        | translate)
                                                                        ? guard?.totalShiftsForCustomer
                                                                        : guard?.totalShiftsForCustomerByJobPlace ||
                                                                        "0"
                                                                        }}
                                                                        {{ "create-assignment.step3.previous-jobs" |
                                                                        translate }}</span>
                                                                </div>
                                                                <div *ngIf="
                                                                        filterby !==
                                                                            ('create-assignment.step3.filter.highestRated'
                                                                                | translate) &&
                                                                        guard
                                                                            .rates
                                                                            .length
                                                                    ">
                                                                    <p style="
                                                                            font-size: 12px;
                                                                            font-weight: 400;
                                                                        ">
                                                                        {{ "create-assignment.step3.Last worked" |
                                                                        translate }}:
                                                                        {{
                                                                        guard
                                                                        ?.lastUsedAtJobPlaceOfCustomer
                                                                        ?.last_used_at
                                                                        | date
                                                                        : "MMMM d, y"
                                                                        }}
                                                                        ({{
                                                                        guard
                                                                        ?.lastUsedAtJobPlaceOfCustomer
                                                                        ?.jobPlaceName
                                                                        }})
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-4 selectedGuard">
                                    <h5 class="">
                                        {{ "create-assignment.step3.selected-guards" | translate }}
                                        <span class="">{{ selectedPersonnelDetails.length }} / {{ numberOfGuard
                                            }}</span>
                                    </h5>
                                    <div class="usercardmainBox" id="hand-pick-id">
                                        <div class="usercard w-full !grid gap-2 relative pr-9" *ngFor="
                                                let guard of selectedPersonnelDetails;
                                                let inx = index
                                            ">
                                            <div class="userName flex gap-2" (click)="openGuardDetailsModal(guard)">
                                                <div class="userImage">
                                                    <img src="{{
                                                            guard.image ||
                                                                '/assets/img/empty-profile-picture.png'
                                                        }}" alt="{{
                                                            guard?.firstName
                                                        }}" class="" />
                                                </div>
                                                <div class="userNameReview">
                                                    <p class="font-medium text-gray-800">
                                                        {{ guard?.firstName }}
                                                    </p>
                                                    <div class="reviewSection">
                                                        <div class="flex">
                                                            <ngb-rating max="5" [rate]="
                                                                    guard?.averageRating
                                                                " [readonly]="
                                                                    true
                                                                "></ngb-rating>
                                                        </div>
                                                        <span class="text-xs text-gray-500 ml-1.5">{{
                                                            guard?.averageRating }}</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <span class="previousJob">{{
                                                filterby ===
                                                ("create-assignment.step3.filter.highestRated"
                                                | translate)
                                                ? guard?.totalShiftsForCustomer
                                                : guard?.totalShiftsForCustomerByJobPlace ||
                                                "0"
                                                }}
                                                {{ "create-assignment.step3.previous-jobs" | translate }}</span>
                                            <button
                                                class="text-sm text-red-600 hover:text-red-800 rounded hover:bg-red-50 w-auto h-auto"
                                                (click)="
                                                    onChangePersonnel(guard)
                                                ">
                                                <img src="../../../../../assets/img/close-red.svg" alt=""
                                                    class="absolute top-3 right-3" />
                                            </button>
                                        </div>
                                    </div>
                                    <div class="noGuards" *ngIf="!selectedPersonnelDetails.length">
                                        <div class="max-w-xs">
                                            {{ "create-assignment.step3.no-guards-selected" | translate }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="guard-card">
                <div class="guard-header">
                    <h3 class="guard-title">
                        {{ "create-assignment.step3.number-of-guards" | translate }}
                        <span class="required">*</span>
                    </h3>
                </div>
                <div class="guard-control">
                    <button class="control-btn" [disabled]="numberOfGuard == 1 ? true : false"
                        (click)="onDecreaseGuard()">
                        -
                    </button>
                    <div class="input-wrapper">
                        <input disabled type="number" min="1" (input)="numberOfGuardCount($event)"
                            [(ngModel)]="numberOfGuard" class="guard-input" />
                    </div>
                    <button class="control-btn" (click)="onIncreaseGuard()" aria-label="Increase Guard">
                        +
                    </button>
                </div>
                <p class="guard-note">
                    {{ "create-assignment.step3.specify-guards" | translate }}
                </p>
            </div>
            <div class="hours-card" *ngIf="dates.length > 0">
                <div class="hours-header">
                    <h3 class="hours-title">
                        {{ "create-assignment.hours" | translate }} ({{
                        dates.length
                        }})
                    </h3>
                </div>
                <div class="prefill-info">
                    <i><img src="../../../../../assets/img/time.svg" loading="lazy" alt="time" /></i>
                    <span>{{ "create-assignment.step3.pre-filled" | translate }}</span>
                </div>
                <div class="shift-limits">
                    <span>{{
                        "Minimum shift duration:"
                        | translate : { number: minShiftDuration }
                        }}</span>
                    <span>{{
                        "Maximum shift duration:"
                        | translate : { number: maxShiftDuration }
                        }}</span>
                </div>
                @for(date of dates; track $index) {
                <div class="time-box">
                    <div class="time-block">
                        <div class="time-date">
                            {{ date.date | date : "d MMMM y" }}
                        </div>
                        <div class="time-range">
                            <div class="time-input-wrapper" [ngClass]="
                                    calculateTime(
                                        date,
                                        date?.startTime,
                                        date?.endTime
                                    ) < minShiftDuration
                                        ? 'active'
                                        : calculateTime(
                                              date,
                                              date?.startTime,
                                              date?.endTime
                                          ) > maxShiftDuration
                                        ? 'active'
                                        : ''
                                ">
                                <div>
                                    <input type="time" name="start-time" [value]="date?.startTime || '16:00'" (change)="
                                            onSetDateStartTime(
                                                $event,
                                                date.date
                                            )
                                        " class="time-input" />
                                    <i><img src="../../../../../assets/img/time-circle.svg" alt="" /></i>
                                </div>
                                <div class="dash hidden sm:block">—</div>
                            </div>
                            <div class="time-input-wrapper" [ngClass]="
                                    calculateTime(
                                        date,
                                        date?.startTime,
                                        date?.endTime
                                    ) < minShiftDuration
                                        ? 'active'
                                        : calculateTime(
                                              date,
                                              date?.startTime,
                                              date?.endTime
                                          ) > maxShiftDuration
                                        ? 'active'
                                        : ''
                                ">
                                <input type="time" class="time-input" name="end-time" [value]="date?.endTime || '20:00'"
                                    (change)="
                                        onSetDateEndTime(
                                            $event.target.value,
                                            date.date
                                        )
                                    " />
                                <i><img src="../../../../../assets/img/time-circle.svg" alt="" /></i>
                            </div>
                        </div>
                    </div>
                    <div class="duration-box">
                        <p class="hours-p" [ngClass]="
                                calculateTime(
                                    date,
                                    date?.startTime,
                                    date?.endTime
                                ) < minShiftDuration
                                    ? 'active-p'
                                    : calculateTime(
                                          date,
                                          date?.startTime,
                                          date?.endTime
                                      ) > maxShiftDuration
                                    ? 'active-p'
                                    : ''
                            ">
                            {{ "create-assignment.step3.duration" | translate }}:
                            {{ calculateDurationTime(date, date?.startTime, date?.endTime) }}
                        </p>
                    </div>
                </div>
                }
            </div>
            <div class="contact-card">
                <div class="contact-header">
                    <h3 class="contact-title">
                        {{ "create-assignment.contact" | translate }}
                    </h3>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                        <circle cx="12" cy="7" r="4"></circle>
                    </svg>
                </div>
                <form [formGroup]="contactForm">
                    <div class="form-group">
                        <label for="contactName" class="form-label">{{ "create-assignment.name" | translate }}
                            <span class="required">*</span>
                        </label>
                        <input type="text" id="contactName" placeholder="{{
                                'create-assignment.full-name-placeholder'
                                    | translate
                            }}" class="form-input" formControlName="name" />
                    </div>
                    <div class="form-group">
                        <label for="contactPhone" class="form-label">{{ "create-assignment.phone" | translate }}
                            <span class="required">*</span>
                        </label>
                        <div class="input-icon-wrapper">
                            <img src="../../../../../assets/img/call.svg" alt="" />
                            <input type="tel" id="contactPhone" placeholder="+46 703 123 45 67" class="form-input pl-40" maxlength="20" formControlName="phone" (input)="onPhoneInput($event)" />
                        </div>
                    </div>
                </form>
            </div>

            <div class="card billing-info">
                <div class="card__header">
                    <h3 class="card__title">
                        {{ "company.billing.billing-info" | translate }}
                    </h3>
                    <svg class="card__icon text-blue-600" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                        fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round">
                        <rect width="20" height="14" x="2" y="5" rx="2" />
                        <line x1="2" x2="22" y1="10" y2="10" />
                    </svg>
                </div>
                <div class="card__content">
                    <form [formGroup]="storeBillingInformation">
                        <div class="form-group">
                            <label for="billingReference" class="form-label">{{
                                "company.billing.reference" | translate
                                }}<span class="required">*</span></label>
                            <input type="text" id="billingReference" class="form-input" placeholder="{{
                                    'company.billing.reference-placeholder'
                                        | translate
                                }}" formControlName="contactName" />
                        </div>
                        <div class="form-group" *ngIf="showEditBillingButton">
                            <button type="button" (click)="openBillingEditModal()" class="edit-billing-btn">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" aria-hidden="true" class="edit-billing-btn__icon">
                                    <path
                                        d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z">
                                    </path>
                                    <path d="m15 5 4 4"></path>
                                </svg>
                                {{ "company.billing.edit-billing" | translate }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            <div class="price-summary-card">
                <h3>
                    {{ "create-assignment.step3.price-summary" | translate }}
                </h3>
                <div class="price-summary">
                    <div class="price-row">
                        <span>
                            {{ prices?.datesWithPrice?.length > 1
                            ? ('create-assignment.step3.hourly-rate-average' | translate)
                            : ('create-assignment.step3.hourly-rate' | translate) }}
                        </span>
                        <span class="price">{{ ratePerHour(prices?.datesWithPrice) }} kr/h</span>
                    </div>

                    <div class="price-row">
                        <span>{{ "create-assignment.step3.number-of-guards" | translate }}:</span>
                        <span class="price">{{
                            prices?.guardsNumber || "0"
                            }}</span>
                    </div>

                    <div class="price-row">
                        <span>{{ "create-assignment.step3.total-time" | translate }}:</span>
                        <span class="price">
                            {{ getTotalDurationFromDates() }}
                        </span>
                    </div>

                    <div class="price-row">
                        <span>{{ "create-assignment.step3.number-of-days" | translate }}:</span>
                        <span class="price">{{ prices?.datesWithPrice.length || "0" }}</span>
                    </div>

                    <div class="total">
                        <div class="price-row total-price">
                            <span>{{ "create-assignment.step3.total-price" | translate }}:</span>
                            <span>{{ prices?.estimatedPrice }} kr</span>
                        </div>
                        <p class="note">
                            {{ "create-assignment.step3.price-note" | translate }}
                        </p>
                    </div>
                    <span class="summary-break-down" *ngIf="prices?.datesWithPrice?.length > 1"
                        (click)="openSummaryBreakModal()">
                        {{ "create-assignment.step3.price-summary-breakdown" | translate }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Bottom Sheet -->
<!-- [ngClass]="{ 'visible': showBottomSheet && prices }" -->
<div class="bottom-sheet">
    <div class="sheet-content">
        <div class="left-info">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-calendar" aria-hidden="true">
                <path d="M8 2v4"></path>
                <path d="M16 2v4"></path>
                <rect width="18" height="18" x="3" y="4" rx="2"></rect>
                <path d="M3 10h18"></path>
            </svg>
            <div class="date">
                <p>
                    <strong>
                        {{ prices?.datesWithPrice.length || "0" }}
                        {{ (prices?.datesWithPrice.length || 0) === 1
                        ? ('create-assignment.step3.dates-selected' | translate)
                        : ('create-assignment.step3.dates-selected' | translate) }}
                    </strong>
                </p>
                <p>
                    <span>
                        {{ prices?.guardsNumber || "0" }}
                        {{ (prices?.guardsNumber || 0) === 1
                        ? ('create-assignment.step3.guards' | translate)
                        : ('create-assignment.step3.guards-plural' | translate) }}
                        • {{
                        handPick == "1"
                        ? ("create-assignment.step3.personnel-apply.label" | translate)
                        : ("create-assignment.step3.hand-pick-personnel.label" | translate)
                        }}
                        • {{ prices?.estimatedPrice }} kr
                    </span>
                </p>

            </div>
        </div>
        <div class="action-buttons">
            <button class="btn-outline backButton" [routerLink]="'/components/assignments/create-assignment/step2'">
                {{
                "create-assignment.step3.back" | translate
                }}
            </button>
            <button class="btn-primary saveButton" (click)="onSave()"
                [disabled]="!isStep3Valid() || (showEditBillingButton && !isOrganisationNumberValidForSave)">
                <span>{{
                    "create-assignment.step3.Save and Continue" | translate
                    }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-chevron-right" aria-hidden="true">
                    <path d="m9 18 6-6-6-6"></path>
                </svg>
            </button>
        </div>
    </div>
</div>